module.exports = __webpack_public_path__ + "static/media/img14.15d0a539.jpg";